import type React from 'react'

import css from './styles.module.css'

export const Loader: React.FC = () => (
  <div className={css.dots_loader_container}>
    <div className={css.dot} />
    <div className={css.dot} />
  </div>
)
